import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import '../../css/header.css'; // CSS styles below should be placed in this file
import { getWhatIsMyBusiness, logout } from '../../Redux/Actions/UserAction';
import NavDrawer from './NavDrawer';

const BUSINESS_KEYS = {
  CAR01: 'sp-spare-parts-business',
  CAR02: 'sp-garages-business',
  CAR03: 'sp-car-dealers-business',
  CAR04: 'sp-rent-car-business',
  CAR06: 'sp-car-wash-business',
  CAR07: 'sp-car-insurance-business',
  CAR08: 'sp-driving-school-business',
  CAR09: 'sp-car-protection-business',
  CAR10: 'sp-car-towing',
  CAR11: 'sp-taxi-business',
  CAR12: 'sp-air-conditioning-business',
  CAR13: 'sp-quick-services-business',
  CAR14: 'carAgentId',
};

const Header = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const currentLang = i18n.language === 'ar' ? 'ar' : 'en';
  const applyDir = (lang) => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  };
  useEffect(() => {
    applyDir(currentLang);
  }, [currentLang]);
  const toggleLanguage = () => {
    const next = currentLang === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(next);
    localStorage.setItem('lang', next);
    applyDir(next);
  };

  const home = useSelector((state) => state.home);
  const getMybusiness = home?.getMybusiness;

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const LogOut = (e) => {
    if (e) e.preventDefault();
    dispatch(logout());
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    if (sessionStorage.getItem('loged_In') === 'true') {
      dispatch(getWhatIsMyBusiness());
    }
  }, [dispatch]);

  // Re-fetch the owner's business on every route change. Creating a business
  // navigates (hash change) without a full reload, so without this the sidebar
  // would stay locked / "Buy Subscription" hidden until a manual refresh.
  useEffect(() => {
    const onHashChange = () => {
      if (sessionStorage.getItem('loged_In') === 'true') {
        dispatch(getWhatIsMyBusiness());
      }
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [dispatch]);

  useEffect(() => {
    if (getMybusiness && Object.keys(getMybusiness).length > 0) {
      sessionStorage.setItem(
        'paymentPlan',
        getMybusiness?.plan_info && getMybusiness?.daysLeft > 0 ? true : false
      );
      sessionStorage.setItem('BusinessId', getMybusiness?.businessId);
    }
  }, [getMybusiness]);

  return (
    <>
      {/* Header Top */}
      <div className="header-a">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-auto">
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <button
                  type="button"
                  onClick={toggleLanguage}
                  className="lang-toggle"
                  style={{
                    background: 'transparent',
                    border: '1px solid currentColor',
                    borderRadius: '4px',
                    padding: '1px 10px',
                    cursor: 'pointer',
                    font: 'inherit',
                    color: 'inherit',
                  }}
                  aria-label="Change language"
                >
                  {currentLang === 'ar' ? 'English' : 'العربية'}
                </button>
                <div className="dropdown dropdown-settings-desktop">
                  {sessionStorage.getItem('loged_In') === 'true' && (
                    <>
                      <a
                        className="dropdown-toggle"
                        href="#"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {t('Settings')}
                      </a>
                      <div className="dropdown-menu">
                        <Link
                          to="/settings-edit-profile"
                          className="dropdown-item"
                        >
                          {t('Edit Profile')}
                        </Link>
                        <Link
                          to="/settings-saved-items"
                          className="dropdown-item"
                        >
                          {t('Saved Items')}
                        </Link>
                        <Link
                          to="/settings-recently-viewed-cars"
                          className="dropdown-item"
                        >
                          {t('Recently Viewed Cars')}
                        </Link>
                        <Link to="/settings-my-posts" className="dropdown-item">
                          {t('My Posts')}
                        </Link>
                        {getMybusiness?.businessId ? (
                          <Link
                            to={`/${BUSINESS_KEYS[getMybusiness?.businessCode] || 'sp-dashboard'}`}
                            className="dropdown-item"
                          >
                            {t('Manage Business')}
                          </Link>
                        ) : (
                          <Link
                            to="/settings-become-a-seller"
                            className="dropdown-item"
                          >
                            {t('Become a Seller')}
                          </Link>
                        )}
                        <a href="#" className="dropdown-item" onClick={LogOut}>
                          {t('Logout')}
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Header Bottom */}
      <div className="header-b">
        <div className="container">
          <div className="wsmobileheader clearfix">
            <a
              href="#"
              id="wsnavtoggle"
              className="wsanimated-arrow"
              onClick={(e) => {
                e.preventDefault();
                setMobileMenuOpen(true);
              }}
            >
              <span></span>
            </a>
            <span className="smllogo">
              <a href="/">
                <img src="assets/images/car-avenue-logo.svg" alt="Car Avenue" />
              </a>
            </span>
          </div>

          {/* Desktop Main Menu */}
          <div className="wsmainfull clearfix d-none d-md-block">
            <div className="wsmainwp d-flex justify-content-between align-items-center">
              <div className="desktoplogo">
                <a href="/">
                  <img
                    src="assets/images/car-avenue-logo.svg"
                    alt="Car Avenue"
                  />
                </a>
              </div>
              <nav className="wsmenu clearfix">
                <ul className="wsmenu-list">
                  <li>
                    <a href="/">{t('Home')}</a>
                  </li>
                  <li aria-haspopup="true">
                    <Link
                      to={
                        sessionStorage.getItem('loged_In') === 'true'
                          ? '/sp-cars-for-sale'
                          : '/login'
                      }
                    >
                      {t('Add Car for Sale')}
                    </Link>
                  </li>
                  {sessionStorage.getItem('loged_In') !== 'true' && (
                    <>
                      <li>
                        <Link to="/login">{t('login')}</Link>
                      </li>
                      <li>
                        <Link to="/register">{t('Register')}</Link>
                      </li>
                    </>
                  )}
                  {sessionStorage.getItem('loged_In') === 'true' && (
                    <>
                      <li aria-haspopup="true">
                        <Link
                          to="/login"
                          style={
                            sessionStorage.getItem('loged_In') === 'true'
                              ? { display: 'none' }
                              : null
                          }
                        >
                          {t('login')}
                        </Link>
                      </li>
                      <li aria-haspopup="true">
                        <Link
                          to="/register"
                          style={
                            sessionStorage.getItem('loged_In') === 'true'
                              ? { display: 'none' }
                              : null
                          }
                        >
                          {t('Register')}
                        </Link>
                      </li>
                      <li aria-haspopup="true">
                        <a href="javascript:void(0)">
                          {t('Services')}
                          <span class="wsarrow"></span>
                        </a>

                        <ul class="sub-menu sub-menu-services">
                          <div class="row d-flex justify-content-center">
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-garages">
                                  <img
                                    src="assets/images/service-icons/garage.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Garages')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-spare-parts">
                                  <img
                                    src="assets/images/service-icons/spare-parts.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Spare Parts')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-car-dealers">
                                  <img
                                    src="assets/images/service-icons/car-dealer.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Car Dealers')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-cars-for-sale">
                                  <img
                                    src="assets/images/service-icons/car-for-sale.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Car for Sale')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-rent-car">
                                  <img
                                    src="assets/images/service-icons/garage.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Rent a Car')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-taxi">
                                  <img
                                    src="assets/images/service-icons/taxi.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Taxi')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-car-wash">
                                  <img
                                    src="assets/images/service-icons/car-wash.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Car Wash')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-towing">
                                  <img
                                    src="assets/images/service-icons/car-towing.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {/* [CF 2026-08-17] Was raw English while every
                                      sibling in this menu was translated. */}
                                  {t('Car Towing')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-car-insurance">
                                  <img
                                    src="assets/images/service-icons/car-insurance.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Car Insurance')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-driving-schools">
                                  <img
                                    src="assets/images/service-icons/driving-school.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Driving School')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-car-protection">
                                  <img
                                    src="assets/images/service-icons/car-protection.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Car Protection')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-air-conditioning">
                                  <img
                                    src="assets/images/service-icons/air-conditioning.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Air Conditioning')}
                                </Link>
                              </li>
                            </div>
                            <div class="col-6 col-lg-2 col-md-6 col-sm-6">
                              <li>
                                <Link to="/user-quick-services">
                                  <img
                                    src="assets/images/service-icons/quick-services.svg"
                                    alt=""
                                    class="img-fluid"
                                  />
                                  <br />
                                  {t('Quick Services')}
                                </Link>
                              </li>
                            </div>
                            {/* <div class='col-6 col-lg-2 col-md-6 col-sm-6'>
													<li>
														<Link to='/user-cars-agents'>
															<img
																src='assets/images/service-icons/cars-agents.svg'
																alt=''
																class='img-fluid'
															/>
															<br />
															Car Agents
														</Link>
													</li>
												</div> */}
                          </div>
                        </ul>
                      </li>
                      {/* [CF] Removed the duplicate top-nav "Manage" link — the
                          Settings dropdown already has "Manage Business" /
                          "Become a Seller", so this was a second Manage entry. */}

                      <li aria-haspopup="true">
                        <a
                          onClick={LogOut}
                          href="#"
                          style={
                            sessionStorage.getItem('loged_In') !== 'true'
                              ? { display: 'none' }
                              : null
                          }
                        >
                          {t('Logout')}
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* [CF 2026-08-09 #16] Shared with the home page — see NavDrawer.js. */}
      <NavDrawer open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </>
  );
};

export default Header;
